module.exports = __webpack_public_path__ + "img/language.a84ceaa6.svg";